import {ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {PERMISSION} from '@generated-backend-types';
import {TabSwitcherComponent} from '../../../components/tab-switcher/tab-switcher.component';
import {TabSwitcherConfig} from '../../../components/tab-switcher/tab-switcher-configuration.interface';
import {IfHasAnyPermissionDirective} from '../../../directives/if-has-any-permission.directive';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-process-tab-switcher',
  standalone: true,
  imports: [TabSwitcherComponent, IfHasAnyPermissionDirective],
  template: `
    <app-tab-switcher
      [config]="config"
      *appIfHasAnyPermissions="[
        PERMISSION.QUALITYMANAGEMENT_PROCESS_READ_ALL,
        { permission: PERMISSION.QUALITYMANAGEMENT_PROCESS_READ_ALL, modelId: processId }
      ]"
    ></app-tab-switcher>
  `,
})
export class ProcessTabSwitcherComponent implements OnChanges {
  @Input({required: true}) public processId!: string;
  protected config: TabSwitcherConfig[] = [];
  protected readonly PERMISSION = PERMISSION;
  private readonly tabs: TabSwitcherConfig[] = [
    {
      link: '/current',
      translationKey: 'authenticated.quality-management.processes.edit.tabs.current-version',
      exact: true
    },
    {
      link: '',
      translationKey: 'authenticated.quality-management.processes.edit.tabs.next-version',
      exact: true
    },
    {
      link: '/versions',
      translationKey: 'authenticated.quality-management.processes.edit.tabs.versions',
      exact: false
    },
  ];

  public ngOnChanges(changes: SimpleChanges): void {
    if ('processId' in changes && this.processId != null) {
      const baseUrl = `/quality-management/processes/${this.processId}`;
      this.config = this.tabs.map(t => ({
        link: `${baseUrl}${t.link}`,
        translationKey: t.translationKey,
        exact: t.exact,
      }));
    }
  }
}
